import { useI18n } from '../../../../shared/i18n/useI18n.js';

import { ACTION_IDS }   from '../../constants/catalogDataDisplay.js';
import { renderActionButtons } from '../ProductActions/renderActionButtons.js';

import { Button }       from '../../../../shared/ui/Button/Button.jsx';
import { HeartButton }  from '../../../../shared/ui/HeartButton/HeartButton.jsx';
import { Plan }         from '../../../../shared/ui/icons/Plan.jsx';
import { Tooltip }      from '../../../../shared/ui/Tooltip/Tooltip.jsx';

import styles from './ProductList.module.scss';

export function ProductActionsCell({ product, context }) {
	const { t } = useI18n();
	const {
		activeActions = [],
		isFavorite,
		toggleFavorite,
		onProductClick,
	} = context;

	const hasAction = (id) => activeActions.some((a) => a.id === id);

	const actionButtonsRenderContext = {
		buttonClass: '', //styles.actionBtn
		size: "small",
		variant: "ghost",
		cta: false,
		isFavorite,
		toggleFavorite,
		onProductClick,
	}

	const orderedActionIds = activeActions.map(a => a.id);

	return (
		<div className={styles.actionsCell}>
			{renderActionButtons({
				context: actionButtonsRenderContext,
				product: product,
				orderedActionIds: orderedActionIds,
			})}
		</div>
	);
}
